export const POLL_INTERVAL = 1_000;
export const MAX_POLL_ATTEMPTS = 30;
